import { Link } from "react-router-dom";
import { collections } from "@/mocks/moments";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CollectionStrip() {
  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Collections"
        title="热门合集整理"
        desc="按主题打包好的补课清单，适合一次性把前因后果看明白。"
        actionPath="/moments"
        actionLabel="全部合集"
      />

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {collections.map((col, index) => (
          <Link
            key={col.title}
            to={`/topic/${col.topicSlug}`}
            className={`group rounded-lg p-6 border flex flex-col transition-colors ${
              index % 2 === 0
                ? "bg-secondary-50 border-secondary-200 hover:border-secondary-400"
                : "bg-background-100 border-background-200 hover:border-primary-300"
            }`}
          >
            <span className="w-11 h-11 rounded-md bg-background-50 flex items-center justify-center text-2xl text-secondary-700">
              <i className={col.icon} />
            </span>
            <h3 className="mt-5 font-heading font-bold text-base text-foreground-950 group-hover:text-primary-600 transition-colors">
              {col.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{col.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-file-list-3-line" />
              收录 {col.count} 篇
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}